import { useNotifications } from "@react-gcc-eds/core";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { useUserAccessRequestActions } from "../../../actions/user-access-request-actions";
import { useStore } from "../../../store";
import { useUserHelpers } from "../../../utils/user-helpers";

const PendingUserRequestsNotification = () => {
  const [notified, setNotified] = useState(false);
  const [state] = useStore();
  const { createInstantNotification } = useNotifications();
  const navigate = useNavigate();

  const { getUnconnectedPendingRequests, getUnapprovedPendingRequests } =
    useUserAccessRequestActions();

  const { userRoleIsSuperUser, userRoleIsAdministrator } = useUserHelpers();

  const notifyPendingRequests = () => {
    if (!notified) {
      try {
        const howMany = state.userAccessRequests.length;
        createInstantNotification(
          "You have pending user requests",
          `${howMany} request${howMany > 1 ? "s" : ""} ${
            howMany > 1 ? "are" : "is"
          } waiting to be processed`,
          "default",
          "info",
          undefined,
          () => navigate("/administration/user-requests")
        );
        setNotified(true);
      } catch {
        console.error("Failed to show pending user requests notification");
      }
    }
  };

  useEffect(() => {
    if (state.user && userRoleIsSuperUser(state.user.role)) {
      getUnconnectedPendingRequests();
    } else if (state.user && userRoleIsAdministrator(state.user.role)) {
      getUnapprovedPendingRequests();
    }
  }, [state.user, state.userRoles]);

  useEffect(() => {
    if (state.userAccessRequests.length) {
      notifyPendingRequests();
    }
  }, [state.userAccessRequests]);

  return null;
};

export default PendingUserRequestsNotification;
